import { render } from "./index.vue?vue&type=template&id=a5fbc774&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a5fbc774&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5fbc774"]])

export default __exports__